module.exports = __webpack_public_path__ + "img/img_size2_test.4d047b12.png";